import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Col, Grid, Row } from 'react-bootstrap';
import utils from '@utils';
import { isEqual } from 'lodash';
import { QuickPaySummary } from './components';

class Final extends Component {
	shouldComponentUpdate({ timeZoneId, receipt }) {
		const lastProps = this.props;

		return (
			isEqual(timeZoneId, lastProps.timeZoneId)
			|| isEqual(receipt, lastProps.receipt)
		);
	}

	render() {
		const {
			invoice, timeZoneId, receipt, hash, type,
		} = this.props;

		const {
			TransactionSummaryItems = [],
			TotalOfficerPay,
			TotalJurisdictionFee,
			TotalOrganizationFee,
			RKPayFee,
			Tax,
		} = invoice;

		const { TransactionId } = receipt;

		let TotalInvoice = 0;
		if (type === '1') TotalInvoice = invoice.TotalInvoice;
		else if (type === 'bulk') TotalInvoice = invoice.Total;

		const PaymentDate = Date.now();

		return (
			<Fragment>
				<div className="margin-top-30">
					<Grid>
						<Row className="margin-bottom-30">
							<Col md={7} sm={12}>
								<div className="text-center margin-bottom-30 padding-left-10 padding-right-10">
									<div className="margin-bottom-20">
										<i className="rkf rkf-check-mark-o-solid font-size-44 color-green-limeade" />
									</div>
									<div className="margin-bottom-20">
										<span className="font-medium font-size-20">Payment Successful</span>
									</div>
									<div>
										<span className="color-gray-shuttle">
											{`Your payment of ${utils.currencyFormatter(TotalInvoice)} `}
											{`was processed successfully on ${utils.parseUTCDateToTimeZone(PaymentDate, timeZoneId).format('MM/DD/YYYY')}.`}
											<br />
											{`Your payment confirmation code is ${TransactionId}.`}
										</span>
									</div>
								</div>

								<div className="quickpay-final">
									<div className="margin-top-30 margin-bottom-20">
										<span className="font-size-24 font-semi-bold">Hire Officers Regularly?</span>
									</div>
									<div className="margin-bottom-15">
										<span className="color-gray-shuttle">
											Create an account to view the details of upcoming jobs across all of your locations,
											approve and pay multiple invoices at the same time, and keep up with the coordinators
											or agencies you work with.
										</span>
									</div>
									<div className="padding-bottom-40">
										<Row>
											<Col sm={6} xs={12}>
												<a
													href={`/signup?quickpayToken=${hash}`}
													className="btn btn-primary form-control"
												>
													Create an Account
													<i className="rkf rkf-arrow-right margin-left-5" />
												</a>
											</Col>
										</Row>
									</div>
								</div>
							</Col>
							<Col md={1} sm={12} />
							<Col md={4} sm={12}>
								<Choose>
									<When condition={type === '1'}>
										<QuickPaySummary
											invoice={invoice}
											timeZoneId={timeZoneId}
											type={type}
											status="paid"
										/>
									</When>
									<When condition={type === 'bulk'}>
										<QuickPaySummary
											invoice={{
												Items                 : TransactionSummaryItems,
												JurisdictionFees      : TransactionSummaryItems,
												TotalServiceCharge    : RKPayFee,
												TotalJurisdictionFees : TotalJurisdictionFee,
												TotalCoordinatorFee   : TotalOrganizationFee,
												TotalInvoice,
												TotalOfficerPay,
												Tax,
											}}
											timeZoneId={timeZoneId}
											type={type}
											status="paid"
										/>
									</When>
								</Choose>
							</Col>
						</Row>
					</Grid>
				</div>
			</Fragment>
		);
	}
}

Final.propTypes = {
	hash       : PropTypes.string,
	invoice    : PropTypes.object,
	receipt    : PropTypes.object,
	timeZoneId : PropTypes.string,
	type       : PropTypes.string,
};

Final.defaultProps = {
	hash       : '',
	invoice    : {},
	receipt    : {},
	timeZoneId : '',
	type       : '',
};

export default Final;
